import { useQuery } from "@apollo/client";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { LocationsQuery } from "../../../graphql/deliveryService/queries/locations";
import { LocationsPagedFragment } from "../../../models/autogenerated-deliveryService-gql/graphql";
import { handleError } from "../../../utils/graphqlHelper";

interface useLocationsQueryProps {
  dataAction: (data: LocationsPagedFragment) => void;
  errorAction?: () => void;
}

const useLocationsQuery = (props: useLocationsQueryProps) => {
  const { t } = useTranslation();
  const { dataAction, errorAction } = props;

  const query = useQuery(LocationsQuery, {
    variables: { offset: 0, limit: 50 },
  });

  const { data, error } = query;

  const locationsPagedFragment = data?.locations;

  useEffect(() => {
    if (!error) return;

    handleError(t("locationsError"), error.message, errorAction);
  }, [error]);

  useEffect(() => {
    if (!data || !locationsPagedFragment) return;

    dataAction(locationsPagedFragment);
  }, [data]);

  return query;
};

export default useLocationsQuery;
